import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsContent, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'cms-ond-faqs',
  templateUrl: 'cms-ond-faqs.component.html',
  styleUrls: ['cms-ond-faqs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsOndFaqsComponent {
  readonly content = input.required<CmsCollection>();

  readonly SvgLibraryIcon = SvgLibraryIcon;

  readonly faqs = computed<CmsContent[]>(() => this.content().items ?? []);

  readonly title = computed<string | undefined>(() => {
    const content = this.content();
    const hasNoTitleTag = (content.subjectTaxonomyTags ?? []).includes(CmsTaxonomyGeneral.NO_TITLE);

    return hasNoTitleTag ? undefined : content.teaserTitle;
  });
}
